import axios from 'axios';
import config from '@/config/config';

const urlMain = config.getParam('apiDomain');

export default {

    getters: {
        accesses: state => state.accesses || [],
    },

    state: {
        accesses: [],
        userHasAccess: true,
        isAnyRequestLoading: true,
    },

    mutations: {
        access_base(state) {
            state.accesses = [];
        },

        access_set(state, data) {
            state.accesses = data;
        },

        setPageAccess(state, data) {
            state.userHasAccess = data;
        },

        SetIsAnyRequestLoading(state, loading) {
            state.isAnyRequestLoading = loading;
        },
    },

    actions: {
        setAccess({ commit }) {
            return new Promise((resolve, reject) => {
                commit('access_base');

                axios({
                    url: (urlMain + 'users/access-list'),
                    method: 'GET',
                })
                    .then(resp => {
                        commit('access_set', resp.data);
                        resolve(resp);
                    })
                    .catch(err => {
                        reject(err.response.data.message);
                    });
            });
        },

        clearAccess({ commit }) {
            commit('access_base');
        },
    },
};